///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables = abcsetup.datatables || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables.table = null;
abcsetup.datatables.button = null;
abcsetup.datatables.column = null;
abcsetup.datatables.value = null;
abcsetup.datatables.search = null;
abcsetup.datatables.reorderTimeout = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    // Add new button clicked
    $(document).on('click', '.dt-add-new-btn', function () {
        if (window.app && window.app.$router) {
            app.$router.push($(this).data('href'));
        } else {
            window.location.href = $(this).data('href');
        }

        return false;
    });

    // Filter reset button clicked
    $(document).on('click', '.dt-reset-btn', function () {
        abcsetup.datatables.search = '';
        abcsetup.blockUI(true);

        var table = $(this).closest('.dataTables_wrapper').find('table.datatable:not(.yajra)');
        table.find('.datatable-filter-btn').data('filter', '').removeClass('active');
        table.find('.datatable-filter-btn').data('filter', '').parent().removeClass('filtered');

        /*
        // Make all columns visible
        table.DataTable().columns().visible(true, false);

        // Hide the .removeCol columns
        table.DataTable().columns('.removeCol').each(function(index) {
            if (this.visible()) {
                this.visible(false, false);
            }
        });
        */

        $('.tooltips, .btn[title]').tooltip('hide');

        // Reset col re-ordering?
        //table.DataTable().colReorder.reset();

        // Reset DT stateSave
        table.DataTable().state.clear();

        table.DataTable().search('').draw();
        table.DataTable().columns().search('').draw();

        return false;
    });

    // Show/Hide All clicked
    $(document).on('click', 'table:not(.yajra) .dt-button.dropdown-item:first-child', function () {
        var dropdown = $(this).parent();
        var table = $(this).closest('.dataTables_wrapper').find('table.datatable');

        var total = dropdown.find('.dt-button.buttons-columnVisibility').length;
        var active = dropdown.find('.dt-button.dropdown-item.active').length;

        // Toggle the Show/Hide All button's class
        $(this).toggleClass('active');

        // Show all columns
        if (active < total) {
            table.DataTable().columns().visible(true, false);
            dropdown.find('.dt-button.buttons-columnVisibility').addClass('active');

            // Hide all columns
        } else {
            table.DataTable().columns().visible(false, false);
            dropdown.find('.dt-button.buttons-columnVisibility').removeClass('active');
        }

        // Hide the .removeCol columns
        table.DataTable().columns('.removeCol').each(function (index) {
            if (this.visible()) {
                this.visible(false, false);
            }
        });
    });

    // Fix the fixedheader/scrollX issue
    $('table:not(.yajra) .dataTables_scrollBody').off('scroll.dataTables').on('scroll.dataTables', function (e) {
        $(this).find('.fixedHeader-floating').css('left', ($(this).scrollLeft() * -1) + $(this).offset().left);
    });
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables = {
    /**
     * Build the datatable
     */
    init: function (table, options = null) {
        // Destroy the datatable if we have one already
        this.reset(table, false);

        // Adjust the column widths based on headers ----------------------------------------------
        var widths = [];
        table.find('thead th').each(function () {
            if ($(this).attr('width')) {
                widths.push($(this).attr('width'));
            } else {
                widths.push(0);
            }

            // Remove extra html from column header
            $(this).find('*').not('.dt-keep').remove();
        });

        table.find('tbody tr').each(function () {
            var row = $(this);
            $(widths).each(function (index) {
                if (this != 0) {
                    row.find('td').eq(index).attr('width', this);
                }
            });
        });
        // ----------------------------------------------------------------------------------------

        this.options = options;

        // options['bInfo'] = options['bInfo'] || true;
        if (options['bInfo'] === undefined) {
            options['bInfo'] = true;
        }

        // options['colReorder'] = options['colReorder'] || true;
        if (options['colReorder'] === undefined) {
            options['colReorder'] = true;
        }

        if (!options['dom']) {
            options['dom'] = 'ltipB';
        }

        options['search'] = {
            regex: true,
            smart: false
        };

        // Remove the specified columns by default
        if (options['remove']) {
            $(options['remove']).each(function () {
                var _index = this;
                table.find('th:eq(' + _index + ')').addClass('noVis removeCol');

                /*
                options['columnDefs'] = options['columnDefs'] || [];
                options['columnDefs'].push({
                    "targets": [_index],
                    "visible": false,
                    "orderable": false,
                });
                */
            });
        }

        options['deferRender'] = true;
        //options['scrollY'] = 150;
        options['scrollCollapse'] = true;
        options['scroller'] = true;

        // We have a search parameter specified ---------------------------------------------------
        var search = abcsetup.getUrlParameter('search');
        if (search) {
            options['oSearch'] = {
                "sSearch": search,
            };
        }
        // ----------------------------------------------------------------------------------------


        // We have column searching parameters specified ------------------------------------------
        options['searchCols'] = [];
        var searchColParam = abcsetup.getUrlParameter('search_cols[]');
        var searchColVals = abcsetup.getUrlParameter('search_vals[]');

        // Format columns into an array
        var columns = [];
        table.find('th').each(function () {
            columns.push({'name': $(this).text().toLowerCase().replace(' ', '_')});
        });

        columns = options['columns'] ? options['columns'] : columns;

        if (searchColParam) {
            $(columns).each(function (i) {
                var idx = searchColParam.indexOf(this.name);

                if (idx == -1) {
                    options['searchCols'].push(null);
                } else {
                    options['searchCols'].push({'sSearch': searchColVals[idx]});
                }
            });
        }
        // ----------------------------------------------------------------------------------------

        // Format/Setup the export buttons --------------------------------------------------------
        var buttonCommon = {
            //columns: ':visible'
            columns: function (idx, data, node) {
                var table_id = node.getAttribute('aria-controls');
                if ($('#' + table_id).find('th').eq(idx).text() == '') {
                    return false;
                }

                return $('#' + table_id).DataTable().column(idx).visible();
            },

            format: {
                // Format the column headers
                header: function (data, column) {
                    data = $('<div>' + data + '</div>');
                    data.find('*').remove();
                    return data.text();
                },

                // Format the body
                body: function (data, column, row) {
                    data = $('<div>' + data + '</div>');
                    data.find('.hide').remove();

                    // Format and remove html and special characters
                    data = data.html().replace(/(<([^>]+)>)/ig, " ").trim();
                    data = abcsetup.replaceAll(data, '&nbsp;', ' ');

                    // Remove the extra spacing
                    while (data.indexOf('  ') > -1) {
                        data = abcsetup.replaceAll(data, '  ', ' ');
                    }

                    return data;
                }
            }
        };

        options['buttons'] = options['buttons'] || [
            //'colvis', 'csv', 'excel', 'pdf',

            {
                extend: 'colvis',
                columns: ':not(.noVis)',
                prefixButtons: [
                    {
                        //extend: 'colvisRestore',
                        text: 'Show/Hide All',
                    },
                ]
            }, {
                extend: 'csv',
                title: '',
                //messageTop: 'The information in this table is copyright to Retail Insights LLC',
                exportOptions: buttonCommon,
            }, {
                extend: 'excel',
                title: '',
                //messageTop: 'The information in this table is copyright to Retail Insights LLC',
                exportOptions: buttonCommon,
            },
            // {
            //     extend: 'pdf',
            //     title: '',
            //     //messageTop: 'The information in this table is copyright to Retail Insights LLC',
            //     exportOptions: buttonCommon,
            // },

            //'copy',
            //'print',
        ];

        // ----------------------------------------------------------------------------------------

        // We're using server-side execution
        if (options['ajax']) {
            //options['buttons'] = ['csv'];

            if (typeof options['ajax'] === 'string') {
                options['ajax'] = {
                    url: options['ajax'],
                    type: 'POST',
                };
            }

            options['processing'] = true;
            //options['searchDelay'] = 350;

            // Custom global search timeout
            options['initComplete'] = function () {
                var api = this.api();
                var searchWaitInterval;

                // Grab the datatables input box and alter how it is bound to events
                $(this).closest('.dataTables_wrapper').find(".dataTables_filter input").unbind().bind("keydown keyup", function (e) {
                    var item = $(this);
                    clearInterval(searchWaitInterval);

                    // The enter key was pressed - force the search
                    if (e.which == 13 && item.val()) {
                        abcsetup.blockUI(true);
                        api.search(item.val()).draw();

                        // Give the user a quick timeout to finish typing
                    } else {
                        searchWaitInterval = setInterval(function () {
                            clearInterval(searchWaitInterval);
                            abcsetup.blockUI(true);
                            api.search(item.val()).draw();
                        }, 1500);
                    }

                    // The enter key was pressed
                    if (e.which == 13) {
                        e.preventDefault();
                        return false;
                    }
                });
            };
        }
        // Apply responsive options
        if (options['responsive'] === undefined) {
            options['responsive'] = {
                details: {
                    renderer: $.fn.dataTable.Responsive.renderer.listHiddenNodes()
                    //renderer: $.fn.dataTable.Responsive.renderer.tableAll()
                }
            };

            // Responsive is turned off - default to use scrollX
        } else if (options['responsive'] === false) {
            //options['scrollX'] = true;
            //table.wrap('<div class="table-scroller"></div>');
        }

        // Apply the saved column visiblity
        options = this.applyColumnVisiblity(table, options);

        // State save options
        // if (typeof options['stateSave'] === 'undefined') {
        //     options['stateSave'] = true;
        // }

        options['stateSave'] = true;
        options['stateDuration'] = -1; // use sessionStorage

        // TODO: set the state of dt-reset-btn based on saved state
        /*
        options['stateSaveCallback'] = function(settings, data) {
            //alert(data.length + '\n\n' + JSON.stringify(data));

            if (data.length == 0) {
                $(this).closest('.dataTables_wrapper').find('.dataTables_filter .dt-reset-btn').attr('disabled', false);
            } else {
                $(this).closest('.dataTables_wrapper').find('.dataTables_filter .dt-reset-btn').attr('disabled', true);
            }
        };
        */
        if (options['scroll_horizontal'] === true) {
            options['scrollX'] = true;
            //table.wrap('<div class="table-scroller"></div>');
        }

        // Specify scrollY attribute / fixedHeader
        if (options['scrollParent']) {
            var offset = options['scrollParentOffset'] ? options['scrollParentOffset'] : 190;
            var parent_height = parseInt(table.closest(options['scrollParent']).height()) - offset;
            options['scrollY'] = parent_height;
        }

        // Automatically detect if DateTable contains columns with date so that we can make the column sortable.
        // https://datatables.net/blog/2014-12-18
        if (options['detectDateCol'] !== undefined) {
            $.fn.DataTable.moment = function ( format, locale, reverseEmpties ) {
                var types = $.fn.DataTable.ext.type;

                // Add type detection
                types.detect.unshift( function ( d ) {
                    if ( d ) {
                        // Strip HTML tags and newline characters if possible
                        if ( d.replace ) {
                            d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
                        }

                        // Strip out surrounding white space
                        d = d.trim();
                    }

                    // Null and empty values are acceptable
                    if ( d === '' || d === null ) {
                        return 'moment-'+format;
                    }
                    return moment( d, format, locale, true ).isValid() ?
                        'moment-'+format :
                        null;
                } );

                // Add sorting method - use an integer for the sorting
                types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
                    if ( d ) {
                        // Strip HTML tags and newline characters if possible
                        if ( d.replace ) {
                            d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
                        }

                        // Strip out surrounding white space
                        d = d.trim();
                    }

                    return !moment(d, format, locale, true).isValid() ?
                        (reverseEmpties ? -Infinity : Infinity) :
                        parseInt( moment( d, format, locale, true ).format( 'x' ), 10 );
                };
            };
            $.fn.DataTable.moment(options['detectDateCol']);
        }
        
        table.show().css('width', '100%');
        this.table = table.DataTable(options);


        // Table was resized
        this.table.on('resize', function () {
            if (options['scrollParent']) {
                var offset = options['scrollParentOffset'] ? options['scrollParentOffset'] : 190;
                var parent_height = parseInt($(this).closest(options['scrollParent']).height()) - offset;
                options['scrollY'] = parent_height;
            }

            console.log('resize - ' + options['scrollY']);
            $(this).closest('.dataTables_scrollBody').css('max-height', options['scrollY']);
        });

        // Column reorder has happened
        if (options['reorderRedraw']) {
            this.table.on('column-reorder', function (e, settings, details) {
                //var headerCell = $(abcsetup.datatables.table.column(details.to).header());
                clearTimeout(abcsetup.datatables.reorderTimeout);
                abcsetup.datatables.reorderTimeout = setTimeout(function() {
                    abcsetup.datatables.table.draw();
                }, 750);
            });
        }

        var _this = this;

        // Popover input field filters
        var headerObj = table;
        if (options['scrollX']) {
            headerObj = table.closest('.dataTables_scroll').find('.dataTables_scrollHead');
        }

        // Colvis button clicked
        $('button.buttons-colvis').on('click', function () {
            var table = $(this).closest('.dataTables_wrapper').find('table.datatable');

            // Determine default state of Show/Hide All button
            if (table.DataTable().columns(':visible').count() == table.DataTable().columns(':not(.removeCol)').count()) {
                $('.dt-button.dropdown-item:first-child').addClass('active');
            }
        });

        // Move the export buttons --------------------------------------------------------------------
        var tableWrapper = table.closest('.dataTables_wrapper');

        // Global search is turned off, add the col where it would've been
        if (tableWrapper.find('.dataTables_filter').length == 0) {
            tableWrapper.find('.dataTables_length').after('<div class="dataTables_filter col"></div>')
        }

        // Format the dom info into bootstrap rows and columns
        //tableWrapper.find('.dataTables_length').parent().addClass('row');
        tableWrapper.find('.dataTables_length, .dataTables_filter').wrapAll("<div class='row'></div>");
        tableWrapper.find('.dataTables_info, .dataTables_paginate').wrapAll("<div class='row'></div>");

        tableWrapper.find('.dataTables_length').addClass('col-4'); // Pagination column
        tableWrapper.find('.dataTables_filter').addClass('col'); // Search/Buttons columns
        tableWrapper.find('.dataTables_info, .dataTables_paginate').addClass('col-6'); // Info and pagination buttons columns

        // Clone default buttons
        var btns = tableWrapper.find('.dt-buttons').addClass('ml-1');

        // Format the buttons
        btns.find('.btn-secondary').removeClass('btn-secondary').addClass('btn-outline-secondary btn-sm');
        btns.find('.buttons-copy').attr('title', 'Copy Table to Clipboard').prepend('<i class="far fa-clipboard mr-2"></i>');
        btns.find('.buttons-csv').attr('title', 'Export to CSV').prepend('<i class="fas fa-file-csv mr-2"></i>');
        btns.find('.buttons-excel').attr('title', 'Export to Excel').prepend('<i class="far fa-file-excel mr-2"></i>');
        btns.find('.buttons-pdf').attr('title', 'Export to PDF').prepend('<i class="far fa-file-pdf mr-2"></i>');
        btns.find('.buttons-colvis').attr('title', 'Column Visibility').prepend('<i class="far fa-eye mr-1"></i>').find('span').remove();
        //btns.find('.buttons-colvis').removeClass('dropdown-toggle');

        // We're using server-side execution
        if (options['ajax']) {
            btns.find('.buttons-csv').off('click').on('click', function () {
                var table = $(this).closest('.dataTables_wrapper').find('.datatable').DataTable();
                abcsetup.datatables.exportAjaxTable('CSV', table);
            });

            btns.find('.buttons-excel').off('click').on('click', function () {
                var table = $(this).closest('.dataTables_wrapper').find('.datatable').DataTable();
                abcsetup.datatables.exportAjaxTable('EXCEL', table);
            });

            btns.find('.buttons-pdf').off('click').on('click', function () {
                var table = $(this).closest('.dataTables_wrapper').find('.datatable').DataTable();
                abcsetup.datatables.exportAjaxTable('PDF', table);
            });
        }

        tableWrapper.find('.dataTables_filter').append(btns);
        tableWrapper.find('.dataTables_filter .dt-buttons').before('<button class="btn btn-sm btn-outline-secondary dt-reset-btn ml-3" title="Reset Table"><i class="fas fa-undo-alt"></i></button>');

        var addText = options['addText'] ? options['addText'] : 'Add New';

        // Add the "Add New" button
        if (options['addBtn']) {
            tableWrapper.find('.dataTables_filter').append('<a href="#" data-href="' + options['addBtn'] + '" class="btn btn-primary btn-sm ml-2 dt-add-new-btn">' + addText + '</a>');
        }

        // Add the "Add New" button linked to a modal
        if (options['addBtnModal']) {
            tableWrapper.find('.dataTables_filter').append('<button class="btn btn-primary btn-sm ml-2" data-toggle="modal" data-target="' + options['addBtnModal'] + '">' + addText + '</button>');
        }

        // Add any extra buttons
        if (options['extraBtns']) {
            $(options['extraBtns']).each(function() {
                tableWrapper.find('.dataTables_filter').append(this);
            });
        }

        // Add tooltips to the global search field
        tableWrapper.find('.dataTables_filter input.form-control').attr('title', 'This is a universal search. Begin typing and your search will be narrowed as additional characters are entered.');
        // --------------------------------------------------------------------------------------------


        //table.show();
        table.resize();
        //table.disableSelection();

        this.table.on('responsive-display', function (e, datatable, row, showHide, update) {
            // The row was shown
            if (showHide) {
                var detailsRow = $(row.node()).next();
                var maxWidth = 0;

                // Find the widest title element
                detailsRow.find('span.dtr-title').each(function () {
                    if ($(this).width() > maxWidth) {
                        maxWidth = $(this).width();
                    }
                });

                // We have a max width
                if (maxWidth > 0) {
                    detailsRow.find('span.dtr-title').width(maxWidth + 20);
                }
            }
        });

        // We're using server-side execution
        if (options['searchVisible'] !== undefined && options['searchVisible'] == false) {
            // Column visibility toggled
            this.table.on('column-visibility.dt', function (e, settings, column, state) {
                var table = $(this).closest('.dataTables_wrapper').find('.datatable').DataTable();

                if (state) {
                    table.settings()[0].aoColumns[column].bSearchable = true;
                } else if (table.settings()[0].aoColumns[column]._notSearchableByDefault) {
                    table.settings()[0].aoColumns[column].bSearchable = false;
                }

                abcsetup.blockUI(true);
                table.draw();
            });
        }

        // Apply the column filtering
        abcsetup.datatables.search.init(table);

        return this.table;
    },


    /**
     * Destory the datatable if we have one already
     */
    reset: function (table, killVals = true) {
        //if (table.DataTable() instanceof $.fn.dataTable.Api) {
        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().colReorder.reset();
            table.DataTable().destroy();
        }

        table.find('.datatable-filter-btn').remove();
        table.hide();

        if (killVals) {
            table.find('tbody tr').remove();
        }
    },


    /**
     * Apply column visibility to the specified options object
     *
     * @param {*} options
     */
    applyColumnVisiblity: function (table, options) {
        abcsetup.datatables.hiddenColumns = [];

        // Find manually hidden columns
        table.find('thead th').each(function (index) {
            if ($(this).hasClass('removeCol')) {
                //if (!$.inArray(abcsetup.datatables.hiddenColumns, index)) {
                abcsetup.datatables.hiddenColumns.push(index);
                //}
            }
        });

        if (abcsetup.datatables.hiddenColumns.length) {
            if (!options['columnDefs']) {
                options['columnDefs'] = [];
            }

            options['columnDefs'].push({
                "targets": abcsetup.datatables.hiddenColumns,
                "visible": false
            });
        }

        // We're using server-side execution
        if (options['searchVisible'] !== undefined && options['searchVisible'] == false) {
            // Dont search hidden columns
            $(options['columns']).each(function (index) {
                if (this.visible == false && this.searchable == null) {
                    this.searchable = false;
                    this._notSearchableByDefault = true;
                }
            });
        }

        return options;
    },

    /**
     * Export the table that's been populated via ajax
     */
    exportAjaxTable: function (format, table, submit = true) {
        var url = (this.options['ajax']['url'] ? this.options['ajax']['url'] : this.options['ajax']);

        if (url.indexOf('?') > -1) {
            url += '&action=EXPORT_' + format;
        } else {
            url += '?action=EXPORT_' + format;
        }

        var data = table.ajax.params();

        // Build a hidden form to handle the file export
        $('form#datatables_download').remove();
        $('body').append('<form id="datatables_download" method="POST" action="' + url + '" class="hide"></form>');

        // Remove invisible columns
        var columns = data['columns'];
        var idxAdjust = 0;

        $(data['columns']).each(function (index) {
            if ($.inArray(index, abcsetup.datatables.hiddenColumns) > -1 || this.name == 'action') {
                columns.splice(index - idxAdjust, 1);

                if (!$.inArray(index, abcsetup.datatables.hiddenColumns)) {
                    if (idxAdjust <= data['order'][0]['column']) {
                        data['order'][0]['column']--;
                    }
                }

                idxAdjust++;
            }
        });

        //alert(JSON.stringify(data['search']));

        $('#datatables_download').append('<input type="hidden" name="draw" value="' + data['draw'] + '">');
        $('#datatables_download').append('<input type="hidden" name="start" value="' + data['start'] + '">');
        $('#datatables_download').append('<input type="hidden" name="length" value="' + data['length'] + '">');
        $('#datatables_download').append('<textarea name="columns">' + JSON.stringify(columns) + '</textarea>');
        $('#datatables_download').append('<textarea name="order">' + JSON.stringify(data['order']) + '</textarea>');
        $('#datatables_download').append('<textarea name="search">' + JSON.stringify(data['search']) + '</textarea>');

        if (submit) {
            $('#datatables_download').submit();
        }
    },
}
